import FJLanguageDropdown from '../view/FJLanguageDropdown.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedLanguageAction } from '../../../../../redux/slices/FJTextBasedEditing.jsx';

const FJLanguageSelectContainer = props => {
    const dispatch = useDispatch();
    const languageList = useSelector(state => state.textBasedEditing.languageList);
    const selectedLanguage = useSelector(state => state.textBasedEditing.selectedLanguage);

    const _onSelectLanguage = language => {
        dispatch(setSelectedLanguageAction(language));
    };

    return (
        <FJLanguageDropdown
            languageList={languageList}
            selectedLanguage={selectedLanguage}
            onClick={_onSelectLanguage}
        />
    );
};

export default FJLanguageSelectContainer;
